import axios from 'axios';
import { CONFIG } from '../global-config';
import { getSessionId } from '../utils/storage';

const axiosInstance = axios.create({
  baseURL: CONFIG.serverUrl,
  headers: {
    'Api-Key': CONFIG.apiKey,
    'Accept-Language': 'en',
    'Content-Type': 'application/json',

  },
});

// Removed the interceptor that was injecting 'Session-Id'
// The instance is now clean and only sends the standard headers defined above.

export default axiosInstance;